/**
 * Cart bubble updater (Horizon-safe) - SINGLE POP
 * - After any successful /cart/add.js request, fetch /cart.js and update the cart count in header.
 * - Pops ONLY ONCE per add (cooldown + count-change check)
 */
(function () {
  "use strict";

  // guard against double-init
  if (window.__CART_FIX_INIT__) return;
  window.__CART_FIX_INIT__ = true;

  const POP_COOLDOWN_MS = 700;
  let lastPopAt = 0;
  let lastCount = null;

  function getBubbleTextEl() {
    // from your earlier setup
    return document.querySelector(".cart-bubble__text") ||
           document.querySelector("[data-cart-count]") ||
           document.querySelector(".cart-count");
  }

  function popOnce() {
    const now = Date.now();
    if (now - lastPopAt < POP_COOLDOWN_MS) return;
    lastPopAt = now;

    const bubbleText = getBubbleTextEl();
    if (!bubbleText) return;

    bubbleText.classList.remove("cart-pop");
    void bubbleText.offsetWidth;
    bubbleText.classList.add("cart-pop");
  }

  function setCount(count) {
    const el = getBubbleTextEl();
    if (!el) return;

    el.textContent = String(count);
    // show/hide if your theme hides at 0
    if (count <= 0) {
      el.style.display = "none";
    } else {
      el.style.display = "";
    }
  }

  async function refreshCountAndPop() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      const cart = await res.json();
      const count = Number(cart.item_count || 0);

      setCount(count);

      // pop only if count changed
      if (lastCount === null) {
        lastCount = count;
        return;
      }
      if (count !== lastCount) {
        lastCount = count;
        popOnce();
      }
    } catch (e) {}
  }

  // Intercept add-to-cart calls (original method that worked for you)
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);

    try {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url;

      // only react to add-to-cart
      if (url && (url.includes("/cart/add") || url.includes("/cart/add.js"))) {
        if (res.ok) {
          // schedule ONE refresh (avoid double triggers)
          setTimeout(refreshCountAndPop, 120);
        }
      }
    } catch (e) {}

    return res;
  };

  // initial sync
  setTimeout(refreshCountAndPop, 200);
})();
